export default __webpack_public_path__ + "static/media/icon-slack.e43b7a11.svg";